import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"
import bem from "../../../bem"
import GridComponent from "../../common/grid/GridComponent"
import {
    Bookmark,
    ICustomContentWidget,
    IGrid,
    IShortcut,
} from "../../../models"

const b = bem.with("NewUI__coverPage")

interface StateProps {
    grid: IGrid
    isLoading: boolean
    bookmarks: Record<string, Bookmark>
    shortcuts: Record<string, IShortcut>
    customContentWidgets?: Record<string, ICustomContentWidget>
}

type Props = StateProps

export class CoverPage extends React.Component<Props> {
    render(): JSX.Element {
        const { bookmarks, shortcuts, customContentWidgets, grid, isLoading } =
            this.props

        return (
            <div
                className={`${b()} tw-p-2 ${
                    isLoading ? "is-placeholder is-loading" : ""
                }`}
            >
                <GridComponent
                    tiles={grid.tiles}
                    isLoading={isLoading}
                    bookmarks={bookmarks}
                    shortcuts={shortcuts}
                    customContentWidgets={customContentWidgets}
                    shouldShowWorkspaceScreenLabel={false}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    grid: state.workspaceCoverPage.grid,
    bookmarks: state.bookmarks.bookmarks,
    shortcuts: state.shortcuts.shortcuts,
    customContentWidgets: state.customContentWidgets.customContentWidgets,
    isLoading: state.workspaceCoverPage.isLoading,
})

export default connect(mapStateToProps, {})(CoverPage)
